import { render, staticRenderFns } from "./PrintCatalog2.vue?vue&type=template&id=45c99084&scoped=true&"
import script from "./PrintCatalog2.vue?vue&type=script&lang=js&"
export * from "./PrintCatalog2.vue?vue&type=script&lang=js&"
import style0 from "./PrintCatalog2.vue?vue&type=style&index=0&id=45c99084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c99084",
  null
  
)

export default component.exports